import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

export interface fileDetails {
  referenceId: string;
  businessName: string;
  contactName: string;
  contactPhone: string;
  contactEmail: string;
  firstName: string;
  lastName: string;
  title: string;
  organizationName: string;
  mailingAddress1: string;
  mailingAddress2: string;
  mailingCity: string;
  mailingState: string;
  mailingZip: string;
  routingOption: string;
  files: File[];
  submittedDate: Date | undefined;
  submittedFileCount: number;
  caseActivityKey: string;
  validateEmail: string;
  emailCode: BigInteger;
}

@Injectable({
  providedIn: 'root'
})
export class FileServiceService {

  referenceFileDetails: fileDetails;
  pageIndex: number = 0;
  authenticatedEmail : string | null = null;
  visitedPages: Set<string> = new Set();
  fileCaptureConfig: any = null;

 constructor(private route: Router) {

  const cached = sessionStorage.getItem('visitedPages');
  this.visitedPages = cached ? new Set(JSON.parse(cached)) : new Set();

  const cachedAuthEmail = window.localStorage.getItem('authenticatedEmail');
  this.authenticatedEmail = cachedAuthEmail ? JSON.parse(cachedAuthEmail) : null;

  window.addEventListener('beforeunload', () => {
    window.localStorage.removeItem('authenticatedEmail');
  });

  this.referenceFileDetails = {
    referenceId: this.getCache("referenceId"),
    businessName: '',
    contactName: '',
    contactPhone: '',
    contactEmail: '',
    firstName: '',
    lastName: '',
    title: '',
    organizationName: '',
    mailingAddress1: '',
    mailingAddress2: '',
    mailingCity: '',
    mailingState: '',
    mailingZip: '',
    routingOption: '',
    files: [],
    submittedDate: undefined,
    submittedFileCount: 0,
    caseActivityKey:'',
    validateEmail:'',
    emailCode: undefined
  };

  this.pageIndex = 0;
}

  setPageVisited(path: string) {
    this.visitedPages.add(path);
    sessionStorage.setItem('visitedPages', JSON.stringify(Array.from(this.visitedPages)));
  }
  hasVisited(path: string): boolean {
    return this.visitedPages.has(path);
  }
  clearVisitedPages() {
    this.visitedPages.clear();
    sessionStorage.removeItem('visitedPages');
  }

  setCacheForitems(items: any[]) {
    items.forEach(element => {
      if (element.value !== undefined && element.value !== null) {
        sessionStorage.setItem(element.id, JSON.stringify(element.value));
      } else {
        sessionStorage.removeItem(element.id);
      }
    });
  }

  getCache(id: string) {
    const item = sessionStorage.getItem(id);

    if (!item || item === "undefined") {
      return null;
    }

    try {
      return JSON.parse(item);
    } catch (e) {
      console.error(`Error parsing cache item "${id}":`, e);
      sessionStorage.removeItem(id); 
      return null;
    }
  }


  clearCache()
  {
    sessionStorage.clear();
    this.authenticatedEmail = null;
    this.reset();
    this.clearVisitedPages(); 
  }

  reset() {
    this.referenceFileDetails = {
      referenceId: '',
      businessName: '',
      contactName: '',
      contactPhone: '',
      contactEmail: '',
      firstName: '',
      lastName: '',
      title: '',
      organizationName: '',
      mailingAddress1: '',
      mailingAddress2: '',
      mailingCity: '',
      mailingState: '',
      mailingZip: '',
      routingOption: '',
      files: [],
      submittedDate: undefined,
      submittedFileCount: 0,
      caseActivityKey: '',
      validateEmail:'',
      emailCode: undefined
    };
    this.pageIndex = 0;
  }

  setConfig(config: any): void {
    this.fileCaptureConfig = config || {};
    const glowColor = this.getConfigValue('RequiredGlowColor', '#00F5B1');
    document.documentElement.style.setProperty('--fc-required-glow-color', glowColor);
    document.documentElement.style.setProperty('--fc-progress-color', glowColor);
  }

  getConfigValue(name: string, fallback: any = null): any {
    if (!this.fileCaptureConfig) {
      return fallback;
    }

    const pascalValue = this.fileCaptureConfig[name];
    if (pascalValue !== undefined && pascalValue !== null) {
      return pascalValue;
    }

    const camelName = name.charAt(0).toLowerCase() + name.slice(1);
    const camelValue = this.fileCaptureConfig[camelName];
    return camelValue !== undefined && camelValue !== null ? camelValue : fallback;
  }

  getConfigBoolean(name: string, fallback: boolean = false): boolean {
    const value = this.getConfigValue(name, fallback);
    if (typeof value === 'boolean') {
      return value;
    }

    if (typeof value === 'number') {
      return value === 1;
    }

    return String(value).toLowerCase() === 'true' || String(value) === '1';
  }

  navigateTo(path: string) {
    this.route.navigate([path]);
  }

   setAuthenticatedEmail(email: string | null) {
    this.authenticatedEmail = email;
    if (email) {
      window.localStorage.setItem('authenticatedEmail', JSON.stringify(email));
    } else {
      window.localStorage.removeItem('authenticatedEmail');
    }
  }

  isEmailAuthenticated(email: string): boolean {
    const cachedAuthEmail = window.localStorage.getItem('authenticatedEmail');
    this.authenticatedEmail = cachedAuthEmail ? JSON.parse(cachedAuthEmail) : null;

    var isAuthenticated = !!email && this.authenticatedEmail === email;
    return isAuthenticated;
  }
}
